import React, { useEffect, useState, useContext } from 'react';
import Select from 'react-select';
import { getAccounts } from '../../services/auth-service';
import { AccountsContext } from '../context/account-context';

const Accounts = () => {
    const { accountId, setAccountId } = useContext(AccountsContext);
    const [accounts, setAccounts] = useState([]);
    const [selectedOption, setSelectedOption] = useState(null);

    useEffect(() => {
        const fetchAccounts = async () => {
            const token = localStorage.getItem('authToken');
            if (!token) {
                console.error('No auth token found');
                return;
            }

            try {
                const response = await getAccounts(token);
                if (response.success) {
                    const accounts = response.data.data || [];

                    // Map accounts to format required by react-select
                    const options = accounts.map((acc) => ({
                        value: acc.accountId,
                        label: acc.name,
                    }));

                    setAccounts(options);

                    // Set default if none selected yet
                    const defaultOption = options.find((opt) => opt.value === accountId) || options[0];
                    setSelectedOption(defaultOption);
                    setAccountId(defaultOption?.value || '');
                } else {
                    console.error('Failed to fetch  accounts:', response.data.message);
                }
            } catch (error) {
                console.error('Error fetching  accounts:', error);
            }
        };

        fetchAccounts();
    }, [accountId, setAccountId]);

    const handleChange = (selected) => {
        setSelectedOption(selected);
        setAccountId(selected?.value || '');
    };

    return (
        <div className="max-w-xs">
            <Select
                options={accounts}
                value={selectedOption}
                onChange={handleChange}
                placeholder="Account"
                className="text-sm"
                isSearchable={false}
                styles={{
                    control: (base, state) => ({
                        ...base,
                        minHeight: '32px',
                        height: '32px',
                        borderRadius: 8,
                        borderColor: '',
                        fontSize: '14px',
                        display: 'flex',
                        alignItems: 'center',
                        boxShadow: 'none', // ✅ remove shadow
                        outline: 'none',    // ✅ remove outline
                        '&:hover': {
                            borderColor: '#60A5FA',
                        },
                    }),
                    valueContainer: (base) => ({
                        ...base,
                        padding: '0 8px',
                        height: '32px',
                        display: 'flex',
                        alignItems: 'center',
                    }),
                    singleValue: (base) => ({
                        ...base,
                        display: 'flex',
                        alignItems: 'center',
                        lineHeight: '2',
                    }),
                    indicatorsContainer: (base) => ({
                        ...base,
                        height: '32px',
                    }),
                    input: (base) => ({
                        ...base,
                        margin: 0,
                        padding: 0,
                    }),
                    dropdownIndicator: (base) => ({
                        ...base,
                        padding: 4,
                    }),
                    clearIndicator: (base) => ({
                        ...base,
                        padding: 4,
                    }),
                }}
            />


        </div>
    );
};

export default Accounts;
